import { Input } from 'components'
import * as React from 'react'
import { Field } from 'redux-form'

const required = value => (value ? undefined : 'Required')

interface IProps {
  onChangeMaskedInput: any
}

export default (props: IProps) => {
  return (
    <form className="signup-form" noValidate={true} autoComplete="off">
      <Field
        props={{
          label: 'Password'
        }}
        name="password"
        type="password"
        component={Input}
        validate={[required]}
      />
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/pages/CreatePassword/Parent/form.tsx